import { Component, input, InputSignal } from '@angular/core';
import { AtomicBlueprintSupported } from '../../shared/atomic/atomic.component';
import { Headline } from 'src/openapi-client';

@Component({
  selector: 'app-headline',
  imports: [],
  templateUrl: './headline.component.html',
  styleUrl: './headline.component.scss'
})
export class HeadlineComponent implements AtomicBlueprintSupported<Headline> {
  data = input.required<Headline>();
}
 